module.exports = __webpack_public_path__ + "static/media/trusted-IIML.d947b874.png";